import { ThemeProvider } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import { buildTheme } from '../theme';
import { useTenant } from './TenantContext';

const ThemeSwitch = props => {
  const { tenant, refreshTenant, subdomain } = useTenant();
  useEffect(() => {
    refreshTenant(subdomain);
  }, [props.subdomain]);
  return (
    <ThemeProvider theme={buildTheme(tenant?.color_primary, tenant?.color_secondary)}>{props.children}</ThemeProvider>
  );
};

export default ThemeSwitch;
